import { AST } from '@handlebars/parser';
import { concatenate } from 'utils/stringHelpers';

const STRIP_WHITESPACE_TOKEN = '~';
const HANDLEBAR_PREFIX = '{{';
const HANDLEBAR_SUFFIX = '}}';
const RAW_PREFIX = '{';
const RAW_SUFFIX = '}';

const stripIf = (condition: boolean) => (condition ? STRIP_WHITESPACE_TOKEN : '');

const formatContent = (content: string, stripFlags: AST.StripFlags) =>
  concatenate([stripIf(stripFlags.open), content, stripIf(stripFlags.close)]);

export const serializeHandlebar = (content: string, stripFlags: AST.StripFlags) =>
  concatenate([HANDLEBAR_PREFIX, formatContent(content, stripFlags), HANDLEBAR_SUFFIX]);

export const serializeRawHandlebar = (content: string, stripFlags: AST.StripFlags) =>
  concatenate([RAW_PREFIX, serializeHandlebar(content, stripFlags), RAW_SUFFIX]);
